import { getTheme, ITheme } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
// import { useUserMessagingActions } from 'adapters/realtime-adapter/actions/messaging';
import { useState } from 'react';
import { useControlNameWidthInMemo } from 'shared-state/display-options/hooks';
import { IProfile } from 'shared-state/identity/types';
import { useMessageComposerUserIds } from 'shared-state/messaging/hooks';
import { makeMessageId, useReceivedMessageInbox } from 'shared-state/notifications/hooks';
import { useUsersWithIDs } from 'shared-state/presence/hooks';
import { useEmittingEvents } from 'services/socket-connection/socket-adapters/event-actions/emittingEvents';

export interface IMemoComposerState {
    userIds: string[];
    users: IProfile[];
    theme: ITheme;
    giphyPanelIsOpen: boolean;
    setGiphyPanelIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    memoBody: string;
    setMemoBody: React.Dispatch<React.SetStateAction<string>>;
    mode: 'markdown' | 'preview';
    setMode: React.Dispatch<React.SetStateAction<'markdown' | 'preview'>>;
    cancel: () => void;
    send: () => void;
}

export const useMemoComposerState: () => IMemoComposerState = () => {
    const [userIds, setUserIds] = useMessageComposerUserIds();
    const users = useUsersWithIDs(userIds);
    const theme = getTheme();
    const { sendMemoToUser } = useEmittingEvents();
    const [giphyPanelIsOpen, setGiphyPanelIsOpen] = useState<boolean>(false);
    const [, addMessage] = useReceivedMessageInbox();
    const [memoBody, setMemoBody] = useState<string>('');
    const [mode, setMode] = useState<'markdown' | 'preview'>('markdown');
    const [, setControlNameWidthInMemo] = useControlNameWidthInMemo();
    const cancel = () => {
        setMemoBody('');
        setMode('markdown');
        setUserIds([]);
        setControlNameWidthInMemo(false);
    };

    const send = () => {
        if (memoBody.length > 0) {
            userIds.forEach((userId: any) => {
                sendMemoToUser(userId, memoBody);
            });

            addMessage({
                id: makeMessageId(),
                type: 'confirmation',
                body: IvicosStrings.memoSentToNotificationActionTitle + users.map((user: any) => user.displayName).join(', ') + '.',
                timeout: 2500,
                meta: {},
                sender: 'system',
                timestamp: new Date()
            });
            cancel();
        }
    };

    return {
        userIds,
        users,
        theme,
        giphyPanelIsOpen,
        setGiphyPanelIsOpen,
        memoBody,
        setMemoBody,
        mode,
        setMode,
        cancel,
        send
    };
};
